import React, { Suspense } from 'react'

import SuspenseRootFallback from './SuspenseRootFallback'

const SuspenseRoot: React.FC = props => {
  return <Suspense fallback={<SuspenseRootFallback />}>{props.children}</Suspense>
}

export default SuspenseRoot
